/** @jsxRuntime classic */ // https://github.com/facebook/create-react-app/issues/9906
import 'polyfills'; // must be the first import

// global styles
import '@clover/web-lib-core-styles/main.scss';
import '@clover/web-lib-consumer-ui/lib/index.css';
import 'styles/global.scss';

import React from 'react';
import ReactDOM from 'react-dom';

// Components
import { Root } from 'Root';
import * as Analytics from 'util/Analytics';

// import i18n (needs to be bundled)
import './i18n';

Analytics.initialize();

ReactDOM.render(<Root />, document.getElementById('root'));
